const Loader = ({ text }) => {
  <div className="flex flex-col items-center justify-center min-h-screen">
    <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-black border-solid"></div>

    <p className="mt-4 text-lg font-semibold text-gray-700">text</p>
  </div>;
};

export default Loader;
